// React
import React from "react";

// Libraries
import PropTypes from "prop-types";
import { Icon } from "semantic-ui-react";

// Context
import { useListRef } from "@Features/Monitor/Context";

// Components
import Text from "@Components/Text";

// Styles
import styles from "./styles.module.css";

const ReplyMessage = ({ item }) => {
	const { listRef } = useListRef();

	const handleReplyClick = async () => {
		await listRef?.current?.scrollToMessage(item.id);
	};

	const renderContent = () => {
		switch (item.type) {
			case "Text":
			case "Interactive":
				return <Text className={styles.text}>{item.text}</Text>;
			case "Image":
				return (
					<div className={styles.row}>
						<Icon className={styles.icon} name="picture" />
						<Text className={styles.text}>Imagen</Text>
					</div>
				);
			case "Note":
				return (
					<div className={styles.row}>
						<Icon className={styles.icon} name="sticky note outline" />
						<Text className={styles.text}>{item.text || "Nota"}</Text>
					</div>
				);
			case "Audio":
				return (
					<div className={styles.row}>
						<Icon className={styles.icon} name="headphones" />
						<Text className={styles.text}>Audio</Text>
					</div>
				);
			case "Video":
				return (
					<div className={styles.row}>
						<Icon className={styles.icon} name="video" />
						<Text className={styles.text}>Video</Text>
					</div>
				);
			case "Location":
				return (
					<div className={styles.row}>
						<Icon className={styles.icon} name="map" />
						<Text className={styles.text}>Ubicacion</Text>
					</div>
				);
			case "Document":
				return (
					<div className={styles.row}>
						<Icon className={styles.icon} name="file" />
						<Text className={styles.text}>Documento</Text>
					</div>
				);
			case "Email":
				return (
					<div className={styles.row}>
						<Icon className={styles.icon} name="envelope" />
						<Text className={styles.text}>Email</Text>
					</div>
				);
			case "Call":
				return (
					<div className={styles.row}>
						<Icon className={styles.icon} name="phone" />
						<Text className={styles.text}>Llamada</Text>
					</div>
				);
			case "Contact":
				return (
					<div className={styles.row}>
						<Icon className={styles.icon} name="id card" />
						<Text className={styles.text}>Contacto</Text>
					</div>
				);
			default:
				return null;
		}
	};

	return (
		<div
			className={`${styles.container} ${item.sentByAgent ? styles.outgoing : styles.incoming}`}
			role="button"
			tabIndex={-1}
			onClick={handleReplyClick}>
			<div className={styles.accent} />
			{renderContent()}
		</div>
	);
};

ReplyMessage.propTypes = {
	item: PropTypes.object,
};

export default ReplyMessage;
